module.exports = __webpack_public_path__ + "static/media/agh100.fedd413d.png";